<template>
  <div>
    <p id="contact-title">{{ $t('Contact me') }}</p>
    <div class="div-row">
      <div
        class="cxs-24 csm-24 cmd-12 clg-12 cxl-12"
        style="margin-bottom: 20px"
      >
        <form @submit.prevent="sendEmail" class="contact-form">
          <div class="div-row">
            <div class="cxs-24 csm-24 cmd-12 clg-12 cxl-12">
              <div class="col-div">
                <div class="input-container">
                  <input
                    type="text"
                    v-model="form.from_name"
                    name="from_name"
                    :placeholder="$t('Name')"
                    autocomplete="off"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="cxs-24 csm-24 cmd-12 clg-12 cxl-12">
              <div class="col-div">
                <div class="input-container">
                  <input
                    v-model="form.from_email"
                    type="email"
                    name="from_email"
                    :placeholder="$t('Email')"
                    autocomplete="off"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="cxs-24 csm-24 cmd-24 clg-24 cxl-24">
              <div class="col-div">
                <div class="input-container">
                  <textarea
                    rows="4"
                    v-model="form.message"
                    name="message"
                    :placeholder="$t('Message')"
                    autocomplete="off"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="cxs-24 csm-24 cmd-24 clg-24 cxl-24">
              <div class="col-div">
                <button
                  class="submit-btn"
                  :class="
                    sending === 0
                      ? 'sending-0'
                      : sending === 1
                      ? 'sending-1'
                      : 'sending-2'
                  "
                  type="submit"
                  :disabled="sending === 1"
                >
                  <img
                    v-show="sending === 2"
                    :style="
                      isRtl ? 'padding-left: 10px' : 'padding-right: 10px'
                    "
                    src="../assets/tick.png"
                    width="20"
                    alt=""
                  />
                  <span>
                    {{
                      sending === 0
                        ? this.$t('Send')
                        : sending === 1
                        ? this.$t('Sending...')
                        : this.$t('Sent')
                    }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="cxs-24 csm-24 cmd-12 clg-12 cxl-12">
        <div id="contact-text">
          <div class="contacts">
            <div>
              <img
                :id="!isRtl ? 'ltr-phone-icon' : 'rtl-phone-icon'"
                width="40"
                src="../assets/phone_icon.png"
                alt="Phone number:"
              />
            </div>
            <div class="contact-value" style="direction: ltr">
              <a
                href="tel:+964 771 152 6617"
                style="text-decoration: none; color: #38285a"
                >+964 770 152 3940</a
              >
            </div>
          </div>
          <div class="contacts">
            <div>
              <img
                width="40"
                src="../assets/mail_icon.png"
                alt="Phone number:"
              />
            </div>
            <div class="contact-value">info@sarkhel.net</div>
          </div>
        </div>

        <div class="social-row">
          <div class="social-col">
            <a href="https://www.facebook.com/sarkhel.saeed" target="_blank">
              <img src="../assets/fb_logo.png" width="30" alt="" />
            </a>
          </div>
          <div class="social-col">
            <a
              href="https://www.instagram.com/sarkhelll/?hl=en"
              target="_blank"
            >
              <img src="../assets/instagram.png" width="30" alt="" />
            </a>
          </div>
          <div class="social-col">
            <a
              href="https://www.linkedin.com/in/sarkhel-saeed-27b890140/"
              target="_blank"
            >
              <img src="../assets/linkedin.png" width="32" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import emailjs from 'emailjs-com'

export default {
  computed: {
    ...mapGetters({
      isRtl: 'getRtl'
    })
  },

  data() {
    return {
      form: {},
      sending: 0
    }
  },

  methods: {
    sendEmail(e) {
      this.sending = 1
      emailjs
        .sendForm(
          'service_sm1yup9',
          'template_kwqje78',
          e.target,
          'user_SlwjacPwv25n5WyvCPJTh'
        )
        .then(
          () => {
            this.sending = 2
            this.form = {}
            setTimeout(() => {
              this.sending = 0
            }, 3000)
          },
          error => {
            console.log('FAILED...', error)
          }
        )
    }
  }
}
</script>

<style lang="scss">
$secondaryColor: #e01e37;
$primaryColor: #38285a;
$backgroundColor: #e1e5e8;

.sending-0 {
  background-color: #e01e37;
  color: white;
  cursor: pointer;
}
.sending-1 {
  cursor: default;
  background-color: #ddd;
  color: $primaryColor;
}
.sending-2 {
  background-color: #1ee06f;
  color: white;
  cursor: default;
}
#contact-me {
  position: relative;
  background-color: #fff;
  padding: 100px 70px;
}

#contact-title {
  text-align: center;
  font-size: 30px;
  padding-bottom: 50px;
  margin: 0px;
}

#contact-text {
  width: 70%;
  margin: auto;
  text-align: center;
  line-height: 1.5;
}

.contacts {
  display: flex;
  justify-content: center;
  justify-items: center;
  margin-bottom: 10px;
}

.contact-value {
  padding: 8px 0px 0px 10px;
  font-size: 18px;
}

#rtl-phone-icon {
  transform: scaleX(-1);
}
#ltr-phone-icon {
  transform: scaleX(1);
}
</style>
